<template>
    <div>
        <div class="row mb-3">
            <div class="col col-12 col-md-4">
                <az-input 
                    placeholder="Todas as Especialidades..."
                    icon="fas fa-filter" 
                    type="select" 
                    optionsMode="esp-ativas"
                    optionsName="esp-ativas"
                    :optionsReload="true"
                    v-model="especialidade" />
            </div>
            <div class="col col-12 col-md-8">
                <az-input 
                    icon="fas fa-search" 
                    v-model="search" />
            </div>
        </div>

        <az-empty-state v-if="!lista.length" />

        <table class="table table-sm bg-white table-hover cabecalho-fixo" v-else>
            <thead>
                <tr>
                    <th>Descrição</th>
                    <th>TUSS</th>
                    <th>SUS</th>
                    <th class="text-center">Tabs</th>
                    <th class="text-center">Profs</th>
                    <th class="text-center">Agendas</th>
                    <th class="text-center">Modelos</th>
                </tr>
            </thead>
            <tbody v-if="dados">
                <tr v-for="(proced, ipx) in lista" :key="ipx" class="small">
                    <td>
                        <a href="#" @click.prevent="$util.abrirProcedimento(proced)" class="card-link">
                            {{ proced.search }}
                        </a>
                        <div class="text-muted" v-if="proced.classe_procedimento">
                            {{ proced.classe_procedimento.search }}
                        </div>
                    </td>
                    <td>
                        {{ proced.st_codigo_cbhpm }}
                    </td>
                    <td>
                        {{ proced.st_codigo_sus }}
                    </td>
                    <td class="text-center" :class="!proced.procedimento_item_tabela_count ? 'bg-warning' : ''">
                        <span v-if="proced.procedimento_item_tabela_count">
                            {{ proced.procedimento_item_tabela_count }}
                        </span>
                    </td>
                    <td class="text-center" :class="!proced.medico_procedimento_unidades_count ? 'bg-warning' : ''">
                        <span v-if="proced.medico_procedimento_unidades_count">
                            {{ proced.medico_procedimento_unidades_count }}
                        </span>
                    </td>
                    <td class="text-center">
                        <span v-if="proced.agenda_procedimento_count">
                            {{ proced.agenda_procedimento_count }}
                        </span>
                    </td>
                    <td class="text-center">
                        <span v-if="proced.lista_modelo_prontuarios_count">
                            {{ proced.lista_modelo_prontuarios_count }}
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data() { 
        return { 
            dados: null, 
            especialidade: "", 
            search: "", 
        }
    },

    components: { 
        AzInput, 
        AzEmptyState, 
    },

    computed: { 
        lista: function () { 
            if ( !this.dados )
                return [];

            let reg = this.$util.getregex(this.search);

            return this.dados.filter (item => ( !this.search || reg.test(JSON.stringify(item) ) ))
                .filter(item => !this.especialidade || item.id_especialidade == this.especialidade.id_especialidade);
        }
    },

    methods: { 
        load() { 
            this.$util.load(this, { 
                service: 'procedimentos.index',
                parms: { 
                    ativos: true, 
                    valid: true, 
                }
            });
        }
    },

    mounted() { 
        this.load();
    }
}
</script>